module.exports = __webpack_public_path__ + "img/open.f680c4a6.png";